module.exports = __webpack_public_path__ + "img/pick3.53c11da4.png";